<template>
    <div class="container-fluid px-0 pb-0 pt-0 mb-5 step-content" id="marker-accordion-outbound-queue">
        <div id="email_table" class="in-email-belt amb-border-top d-flex">
            <div
                class="tab-content in-email-col border-left-0 bg-transparent"
                id="emailQueueContent"
                v-infinite-scroll="scrolled"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="20"
            >
                <div class="tab-pane fade p-0 active show" id="assigned-tab" role="tabpanel" aria-labelledby="assigned">
                    <div class="d-flex flex-column flex-grow-1">
                        <div v-if="Object.keys(emails).length > 0" :key="emailCount">
                            <div v-for="emailGroup in Object.keys(groupedEmails)" :key="emailGroup">
                                <!-- date recd -->
                                <!-- <p class="mb-0 py-1 px-3 in-email-date">{{emailGroup | moment('DD/MM/YYYY')}}</p> -->

                                <!-- cards -->
                                <div
                                    @click="readEmail(email, index)"
                                    class="in-email-summary"
                                    :class="{ current: selectedEmail.email && email.id == selectedEmail.email.id }"
                                    v-for="(email, index) in groupedEmails[emailGroup]"
                                    :key="email.id"
                                    v-if="email"
                                >
                                    <div class="mb-3 d-flex align-items-center">
                                        <p class="mr-3 mb-0">
                                            <small class="text-muted">To</small>
                                            <br/>
                                            {{ formatEmailAddress(email.to) }}
                                            <br/>
                                            <small>Received at:
                                                {{ (email.created_at + "Z") | moment("DD/MM/YYYY hh:mm A") }}</small>
                                        </p>
                                    </div>
                                    <p class="mb-0">
                                        <small class="text-muted">Subject</small>
                                        <br/>
                                        {{ email.subject }}
                                    </p>

                                    <!-- Email Postmark Events -->
                                    <div id="test-tooltips"
                                         class="email-status-container d-flex justify-content-around">
                                        <div v-if="email.events.length === 0" class="events-loading w-100">
                                            <div class="loading-animated-background"></div>
                                        </div>
                                        <div v-else class="status-indicator" v-for="(e, i) in email.events">
                                            <div :id="`event-tooltip-${e.id}`">
                                                <span
                                                    :class="['bubble', { active: e.status, error: e.error, warn: e.warning }]"></span>
                                                <span class="label">{{ e.name }}</span>
                                            </div>
                                            <b-tooltip
                                                :target="`event-tooltip-${e.id}`"
                                                custom-class="email-event-tooltip"
                                                triggers="hover"
                                                v-if="e.info"
                                            >
                                                <ul class="event-tooltips">
                                                    <li>
                                                        <span class="head">Date</span>
                                                        <span class="text">{{
                                                                e.info.receivedat | moment("DD/MM/YYYY hh:mm A")
                                                            }}</span>
                                                    </li>
                                                </ul>
                                            </b-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <h5 class="text-muted mt-5 text-center">No Emails</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-grow-1 bg-white overflow-auto">
                <div class="d-flex justify-content-between px-4 py-2 email-view-title border-top-0"
                     v-if="selectedEmail.email">
                    <el-button :disabled="resendButtonDisabled" @click="resent">
                        <i class="fas fa-envelope"></i>
                        Resend Email
                    </el-button>

                    <div class="d-flex">
                        <!-- Show Events Detail (Auditor Permission Only) -->
                        <a href="#" class="ml-1" title="Delivery Info" @click="toggleEventsViewer"
                           v-if="selectedEmailHasEvents">
                            <i :class="['fas', openEvents ? 'fa-calendar-minus' : 'fa-calendar-plus']"></i>
                            <small class="ml-2">Delivery Info</small>
                        </a>

                        <el-button :disabled="forwardButtonDisabled" @click="forwardEmailModal">
                            <i class="fas fa-share"></i>
                            Forward Email
                        </el-button>
                    </div>
                </div>

                <!-- Detailed view of Postmark events -->
                <div
                    ref="events"
                    :class="[
						'email-events mb-2',
						{
							show: openEvents && selectedEmail.email && selectedEmail.email.rawEvents,
						},
					]"
                    v-if="selectedEmail.email"
                >
                    <div class="email-events-inner">
                        <div v-for="(e, i) in selectedEmail.email.rawEvents" class="event-card">
                            <!-- [Bounced] Card Details -->
                            <div v-if="e.type === 'Bounced'" class="row">
                                <div
                                    :class="[
										'event-card-title',
										{
											'bg-danger': selectedEmail.email.events[i].error,
											'bg-warning': selectedEmail.email.events[i].warning,
										},
									]"
                                >
                                    {{ e.type }}
                                </div>
                                <div class="event-card-line col-6">
                                    <b>Recipient:</b>
                                    <div>{{ e.recipient }}</div>
                                </div>
                                <div class="event-card-line col-6">
                                    <b>Date:</b>
                                    <div>{{ e.receivedat | moment("DD/MM/YYYY hh:mm A") }}</div>
                                </div>

                                <div class="event-card-line col-6">
                                    <b>Bounce ID:</b>
                                    <div>{{ e.details.bounceid }}</div>
                                </div>
                                <div class="event-card-line col-6">
                                    <b>Can Reactivate:</b>
                                    <div>{{ selectedEmail.email.data.canActivate ? "Yes" : "No" }}</div>
                                    <small>Soft bounces can be re-activated and sent again.</small>
                                </div>
                                <div class="event-card-line col-12">
                                    <b>Delivery Message:</b>
                                    <div>{{ e.details.summary }}</div>
                                </div>
                            </div>

                            <!-- [Delivered] Card Details -->
                            <div v-if="e.type === 'Delivered'" class="row">
                                <div class="event-card-title">{{ e.type }}</div>
                                <div class="event-card-line col-6">
                                    <b>Recipient:</b>
                                    <div>{{ e.recipient }}</div>
                                </div>
                                <div class="event-card-line col-6">
                                    <b>Date:</b>
                                    <div>{{ e.receivedat | moment("DD/MM/YYYY hh:mm A") }}</div>
                                </div>

                                <div class="event-card-line col-6">
                                    <b>Destination Server:</b>
                                    <div>{{ e.details.destinationserver }}</div>
                                </div>
                                <div class="event-card-line col-6">
                                    <b>Destination IP:</b>
                                    <div>{{ e.details.destinationip }}</div>
                                </div>
                                <div class="event-card-line col-12">
                                    <b>Delivery Message:</b>
                                    <div>{{ e.details.deliverymessage }}</div>
                                </div>
                            </div>

                            <!-- [Opened] Card Details -->
                            <div v-if="e.type === 'Opened'" class="row">
                                <div class="event-card-title">{{ e.type }}</div>
                                <div class="event-card-line col-6">
                                    <b>Recipient:</b>
                                    <div>{{ e.recipient }}</div>
                                </div>
                                <div class="event-card-line col-6">
                                    <b>Date:</b>
                                    <div>{{ e.receivedat | moment("DD/MM/YYYY hh:mm A") }}</div>
                                </div>

                                <div class="event-card-line col-12">
                                    <b>Summary:</b>
                                    <div>{{ e.details.summary }}</div>
                                </div>
                            </div>

                            <!-- [Clicked] Card Details -->
                            <div v-if="e.name === 'Clicked'" class="row">
                                <div class="event-card-title">{{ e.type }}</div>
                                <div class="event-card-line col-12">
                                    <b>Link:</b>
                                    <div>
                                        <a :href="e.details.link">{{ e.details.link }}</a>
                                    </div>
                                </div>
                                <div class="event-card-line col-12">
                                    <b>Click Location:</b>
                                    <div>{{ e.details.clicklocation }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- email details -->
                <div class="p-2" v-if="selectedEmail.email">
                    <div class="col-12">
                        <p>
                            <strong>To:</strong>
                            {{ formatEmailAddress(selectedEmail.email.to) }}
                        </p>
                        <p>
                            <strong>CC:</strong>
                            {{ selectedEmail.email.cc }}
                        </p>
                        <p>
                            <strong>Subject:</strong>
                            {{ selectedEmail.email.subject }}
                        </p>
                    </div>
                </div>

                <!-- contents of the selected email -->
                <div class="p-2" v-if="selectedEmail.email && selectedEmail.email.attachment_links.length > 0">
                    <p>Attachments:</p>
                    <div style="overflow-x: auto" class="row col-12">
                        <div v-for="(attachment, index) in selectedEmail.email.attachment_links" :key="index"
                             class="btn-group p-2">
                            <a :href="attachment.link" class="btn btn-light-blue" target="_blank">
                                <i class="fas fa-file mr-1"></i>
                                {{ attachment.name }}
                            </a>
                        </div>
                    </div>
                </div>
                <iframe
                    class="px-4 pt-4 pb-5"
                    style="-ms-overflow-y: auto; overflow-y: auto; height: 85%; width: 100%; border: none"
                    ref="emailView"
                ></iframe>
            </div>
        </div>

        <x-modal
            :wWidth="650"
            v-if="forwardModal == true"
            @cancel="forwardModal = false"
            @close="forwardModal = false"
            @ok="forwardMessage"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :okDisabled="!recipients"
            okText="Forward Email"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Forward Email</div>

            <div class="container">
                <div class="row pt-0 amb-modal-body" style="-ms-overflow-y: auto; overflow-y: auto">
                    <div class="col-12 my-3">
                        <div>
                            <div class="input-belt mb-3">
                                <multi-input :model.sync="recipients" label="To"></multi-input>
                            </div>

                            <div class="input-belt mb-3">
                                <multi-input :model.sync="ccRecipients" label="CC"></multi-input>
                            </div>

                            <div class="input-belt mb-3">
                                <h3 for="email-comments">Message</h3>
                                <div class="mt-3 w-100">
                                    <summernote :model.sync="editorData"></summernote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </x-modal>

        <email-forward-reply-modal
            v-if="selectedEmail.email"
            :visible.sync="emailForwardReplyModal.visible"
            :action="emailForwardReplyModal.action"
            :email="selectedEmail.email"
        ></email-forward-reply-modal>

    </div>
</template>
<script>
import {Message} from "element-ui"
import _ from "underscore"

import {mapGetters} from "vuex"
import Loader from "@tenant/ambition/partials/Loader"
import EmailRecipients from "@ambition/components/messages/EmailRecipients"
import EmailAttachments from "@ambition/components/messages/EmailAttachments"
import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
import EmailTask from "@ambition/components/messages/EmailTask"
import EmailForwardReplyModal from "@ambition/components/messages/EmailForwardReplyModal"

function groupBy(list, keyGetter) {
    const map = new Map()
    list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
            map.set(key, [item])
        } else {
            collection.push(item)
        }
    })

    return map
}

export default {
    name: "OutboundQueue",
    components: {
        Loader,
        EmailRecipients,
        EmailAttachments,
        EmailMarkupMulti,
        EmailTask,
        EmailForwardReplyModal
    },
    data() {
        return {
            emailForwardReplyModal: {
                visible: false,
                action: ""
            },
            documentsLoading: false,
            attachmentsTotalSize: 0,
            attachmentsMaxSize: 10,
            docDocuments: [],
            email: {
                uid: "",
                recipients: [],
                cc: [],
                bcc: []
            },
            builderLoading: false,
            builderForwardModal: false,
            selectedEmail: {},
            page: 1,
            isPageLoad: false,
            loading: false,
            emails: [],
            busy: false,
            forwardModal: false,
            openEvents: false,
            canUserAudit: false,
            editorData: ``,
            recipients: "",
            ccRecipients: "",
            resendButtonDisabled: true,
            forwardButtonDisabled: true,
        }
    },
    watch: {
        "email.attachments"(newVal, oldVal) {
            let newSize = 0
            if (!_.isEmpty(newVal)) {
                newVal.forEach((docOptionId) => {
                    const id = parseInt(docOptionId)
                    const doc = this.docDocuments.find((e) => e.id === id)
                    newSize += parseFloat(doc.file_size || 0)
                })
            }
            this.attachmentsTotalSize = parseFloat(newSize).toFixed(2)
        },
    },
    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
        }),
        // attachedDocuments() {
        //     if (!this.selectedEmail) return []
        //     const attachedDocuments = JSON.parse(this.selectedEmail.email.attachments)
        //     if (!_.isNull(attachedDocuments)) {
        // 	    return attachedDocuments.map((attached) => this.docDocuments.find((document) => document.id == attached.id))
        //     }
        //     return []
        // },
        builderForwardDisabled() {
            if (_.isEmpty(this.emailBuilder.recipients) || this.builderLoading) return true
            return false
        },
        docAttachmentDocuments() {
            var thisDocAttachments = new Map()
            if (this.docDocuments) {
                thisDocAttachments = groupBy(this.docDocuments, (doc) => {
                    return (doc.document_type && doc.document_category != "markup"
                            ? doc.document_type.document_type || "Other"
                            : "Other"
                    ).toUpperCase()
                })
                this.documentsLoading = false
            }
            return thisDocAttachments
        },
        emailCount() {
            let noOfEmails = 0
            Object.keys(this.emails).forEach((emailGroup) => {
                noOfEmails += emailGroup.length
            })
            return noOfEmails
        },

        groupedEmails() {
            return _.groupBy(this.emails, (e) => {
                return Moment(e.created_at).format("DD/MM/YYYY")
            })
        },

        selectedEmailHasEvents() {
            const {selectedEmail} = this
            return selectedEmail.email.rawEvents && selectedEmail.email.rawEvents.length > 0
        },
    },
    async mounted() {
        this.nextPage(1)

        this.$bus.$on("reloadSentItems", (data) => {
            this.reloadSentItems()
        })
    },
    beforeDestroy() {
        this.$bus.$off("reloadSentItems")
    },
    methods: {
        getDocuments() {
            this.resendButtonDisabled = true
            this.forwardButtonDisabled = true
            this.documentsLoading = true
            let headers = {
                headers: {Authorization: "Bearer " + this.$store.getters.token},
            }
            axios.get("/api/application/" + this.selectedEmail.email.application_id + "/finalise/documents", headers).then((res) => {
                this.docDocuments = res.data.documents
                this.documentsLoading = false
                this.resendButtonDisabled = false
                this.forwardButtonDisabled = false
            })
        },
        async reloadSentItems(callback) {
            this.emails = []
            await this.nextPage(1)
            if (typeof callback === "function") callback()
        },

        forwardEmailModal() {
            if (Ambition.useEmailBuilder()) {
                this.emailForwardReplyModal.action = 'forward'
                this.emailForwardReplyModal.visible = true
            } else {
                this.forwardEmail()
            }
        },
        forwardEmailBody() {
            let emailSent = this.$moment(new Date(this.selectedEmail.email.created_at)).format("LLLL")
            let emailBody =
                "<section class='container'><br/><br/><br/><br/><p style='border-top: 1px solid #555555; padding-top: 15px;'>---------- Forwarded message ---------<br/>" +
                "From: " +
                this.selectedEmail.email.from_name +
                " <" +
                this.selectedEmail.email.from +
                "><br/>" +
                "Sent: " +
                emailSent +
                "<br/>" +
                "To: " +
                this.selectedEmail.email.to +
                "<br/>"
            if (this.selectedEmail.email.cc != null && this.selectedEmail.email.cc != "[]") {
                emailBody += "Cc: " + this.selectedEmail.email.cc + "<br/>"
            }
            emailBody += "Subject: " + this.selectedEmail.email.subject + "</p></section><br/>" + this.selectedEmail.email.message_body

            return emailBody
        },

        builderEditorData() {
            this.$store.dispatch('builderEmail/setRecipients', [])
            this.emailBuilder.templateUid = this.selectedEmail.email.template_id
            this.emailBuilder.templateHtml = this.forwardEmailBody()
            this.builderForwardModal = true
        },
        forwardEmail() {
            this.$set(this, "forwardModal", true)
            let emailBody = this.forwardEmailBody();
            this.$set(this, "editorData", emailBody)
        },
        async builderForwardMessage() {
            this.builderLoading = true
            await axios.post(
                `/api/builder-email`,
                {
                    email: this.emailBuilder
                },
                this.headers
            )
                .then((response) => {
                    // create application task
                    if (_.get(this.emailBuilder, 'task.create', false)) {
                        this.$store.dispatch("statusIndicators/changeStatus", {
                            stage: "createTask",
                            token: this.$store.getters.token,
                            remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                            taskName: this.emailBuilder.task.name,
                            time: this.emailBuilder.task.time,
                            userId: this.emailBuilder.task.userId,
                            appId: this.$store.getters.initAppData.id
                        })
                    }

                    // create recipient tasks
                    if (_.get(this.emailBuilder, 'recipients', false)) {
                        this.emailBuilder.recipients.forEach(recipient => {
                            if (_.get(recipient, 'template.task.create', false)) {
                                this.$store.dispatch("statusIndicators/changeStatus", {
                                    stage: "createTask",
                                    token: this.$store.getters.token,
                                    remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                                    taskName: recipient.template.task.name,
                                    time: recipient.template.task.time,
                                    userId: recipient.template.task.userId,
                                    appId: this.$store.getters.initAppData.id
                                })
                            }
                        })
                    }
                    this.builderForwardModal = false
                    this.builderLoading = false
                    swal({
                        type: "success",
                        text: "The email has been sent",
                        title: "Success!",
                    })
                })
                .catch((error) => {
                    this.email = {
                        uid: "",
                        recipients: [],
                        cc: [],
                        bcc: [],
                        attachments: [],
                        template: {},
                    }
                    this.builderForwardModal = false
                    this.builderLoading = false
                    swal({
                        type: "error",
                        text: "There was an error sending this email",
                        title: "Error!",
                    })
                })
        },
        async forwardMessage() {
            this.loading = true
            this.forwardButtonDisabled = true
            try {
                let res = await axios.post(
                    `/admin/outbound_mail/${this.selectedEmail.email.id}/forward`,
                    {
                        recipients: this.recipients,
                        ccRecipients: this.ccRecipients,
                        body: this.editorData,
                        template: this.selectedEmail.email.template_id,
                        attachments: this.selectedEmail.email.attachments,
                    },
                    this.headers
                )

                if (res.data) {
                    this.forwardModal = false
                    this.forwardButtonDisabled = false
                    this.$message({
                        message: "Message Forwarded",
                        type: "success",
                    })

                    // Clear recipients and CC for next message
                    this.recipients = null
                    this.ccRecipients = null
                    this.loading = false
                }
            } catch (error) {
                this.forwardButtonDisabled = false
                console.error(error)
                this.$message({
                    message: "Cannot Forward Message",
                    type: "error",
                })
                this.loading = false
            }
        },

        checkPostmarkEvent(email, name) {
            const events = email.postmark.events
            const e = _.findWhere(events, {type: name})
            return {status: e !== undefined, e}
        },

        // Hide / show toggle
        toggleEventsViewer() {
            const isOpen = !this.openEvents
            // const eventsHeight = $(this.$refs.events).innerHeight()
            // this.eventsHeight = isOpen ? eventsHeight : 0
            this.openEvents = isOpen
        },

        formatPostMarkEvents(email, rawEvents, responseData) {
            let events = []

            // The only events that will be shown in the status bar
            let eventNames = [
                "Delivered",
                "Opened",
                "LinkClicked",
                // 'Bounced'
            ]

            // Check if any bounced event for this email
            const bounced = _.findWhere(rawEvents, {type: "Bounced"})
            const softBounced = responseData.canActivate

            // Loop through events and customise them
            eventNames.forEach((name) => {
                const rawEvent = _.findWhere(rawEvents, {type: name})

                const event = {
                    id: `${email.id}-${name}`,
                    name,
                    info: rawEvent,
                    status: rawEvent !== undefined,
                    error: false,
                    warn: false,
                }

                if (event.name === "Delivered" && bounced) {
                    event.name = "Bounced"
                    event.info = bounced
                    if (softBounced) event.warning = true
                    else event.error = true
                }

                if (event.name === "LinkClicked") {
                    event.name = "Clicked"
                }

                events.push(event)
            })

            return events
        },

        getPostmarkEvents(emails) {
            return emails.map((e) => {
                // Load the events
                axios
                    .get(`/admin/outbound_mails/postmark/${this.$store.getters.initAppData.id}`, {
                        params: {
                            emailId: e.id,
                        },
                    })
                    .then((res) => {
                        const data = res.data
                        const events = data.events
                        const formattedEvents = this.formatPostMarkEvents(e, events, data)
                        e.events = formattedEvents
                        e.rawEvents = events
                        e.data = data
                    })
                    .catch((err) => {
                        console.error(err)
                    })
                e.events = []
                return e
            })
        },

        getOutboundEmails(page = false) {
            this.isPageLoad = false

            return new Promise((resolve, reject) => {
                axios
                    .get(`/admin/outbound_mails/${this.$store.getters.initAppData.id}`, {
                        params: {
                            page: page || this.page,
                        },
                    })
                    .then((res) => {
                        const responseData = res.data
                        const emails = responseData.emails.data

                        this.canUserAudit = responseData.canUserAudit
                        this.isPageLoad = true

                        this.getPostmarkEvents(emails)

                        resolve(emails)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
            })
        },

        async reply() {
        },
        scrolled() {
            let bottomWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

            if (bottomWindow) {
                this.busy = true

                if (this.isPageLoad) {
                    this.page += 1
                    this.nextPage(this.page)
                }
            }
            this.busy = false
        },
        async nextPage(page = 1) {
            let emails = await this.getOutboundEmails(page)

            emails.forEach((e) => {
                const exists = this.emails.find((a) => a.id === e.id) !== undefined
                if (!exists) this.emails.push(e)
            })
        },
        resent() {
            if (this.selectedEmail.email) {
                this.resendButtonDisabled = true
                axios
                    .post("/admin/outbound_mail/" + this.selectedEmail.email.id, {})
                    .then((res) => {
                        this.resendButtonDisabled = false
                        swal({
                            type: "success",
                            text: "The email has been resent",
                            title: "Success!",
                        })
                    })
                    .catch((err) => {
                        console.error(err)
                        this.resendButtonDisabled = false
                        swal({
                            type: "danger",
                            text: "There was an error resending this email",
                            title: "Error!",
                        })
                    })
            } else {
                swal({
                    type: "info",
                    text: "Please select an email to resend",
                    title: "Oops!",
                })
            }
        },
        readEmail(email, index) {
            this.$refs.emailView.src = email.preview_url
            this.selectedEmail = {email: email, index: index}

            this.email = {
                uid: "",
                recipients: [],
                cc: [],
                bcc: [],
                attachments: [],
                template: {},
            };

            if (this.selectedEmail.email.application_id) {
                this.getDocuments()
            }
        },
        clickIt(data) {
            location.href = "/admin/outbound_mail/" + data.row.id
        },
        formatEmailAddress(email) {
            // convert json string to comma delimited
            try {
                email = JSON.parse(email).join(", ")
            } catch (e) {
                return email
            }

            return email
        },
    },
}
</script>

<style lang="scss">
.document-types {
    .el-select-dropdown__list {
        padding: 0rem;

        .el-select-dropdown__item {
            font-size: 12px;
            padding: 0 10px;
            position: relative;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #606266;
            height: 30px;
            line-height: 30px;
            box-sizing: border-box;
            cursor: pointer;
        }

        .el-collapse-item__header {
            border-bottom: 1px solid #fbfbfb;
            padding-left: 0.5rem;
            color: #2493ef !important;
        }
    }
}
</style>

<style lang="scss" scoped>
$color-light-grey: #bcc2c7;
$color-blue: #2493ef;
$color-email-status: #eff2f9;

$height: 26px;

.in-email-summary {
    position: relative;
    padding: 16px 16px 40px;
}

.email-status-container {
    background-color: $color-email-status;
    font-size: 11px;
    font-weight: normal;
    width: 100%;
    padding: 0px 16px;
    position: absolute;
    bottom: 0;
    left: 0;
    height: $height;

    .status-indicator {
        $bubble-size: 9px;
        position: relative;
        height: $height;
        line-height: $height;
        white-space: nowrap;
        text-align: center;

        .bubble {
            $color: $color-light-grey;
            width: $bubble-size;
            height: $bubble-size;
            border-radius: 50%;
            display: inline-block;
            background-color: $color;
            border: 1px solid darken($color, 10%);

            &.active {
                $color: #5cbb2a;
                background-color: $color;
                border-color: darken($color, 10%);
            }

            &.warn {
                $color: orange;
                background-color: $color;
                border-color: darken($color, 10%);
            }

            &.error {
                $color: red;
                background-color: $color;
                border-color: darken($color, 10%);
            }
        }

        .label {
            margin-left: 2px;
        }
    }
}

// Loading
@keyframes loading-animated-background {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(46px);
    }
}

.events-loading {
    height: auto;
    text-align: center;
    color: $color-email-status;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-style: italic;
    z-index: 1;
}

.loading-animated-background {
    $color-1: $color-email-status;
    $color-2: darken($color-email-status, 5%);

    position: absolute;
    left: -46px;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;

    background: -webkit-repeating-linear-gradient(145deg, $color-1 1px, $color-2 2px, $color-2 11px, $color-1 12px, $color-1 20px);
    background: repeating-linear-gradient(-55deg, $color-1 1px, $color-2 2px, $color-2 11px, $color-1 12px, $color-1 20px);

    animation-name: loading-animated-background;
    animation-duration: 0.6s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

// Tooltips
ul.event-tooltips {
    list-style-type: none;
    text-align: left;
    margin: 0;
    padding: 0;

    li {
        color: #fff;
        font-size: 12px;

        .head {
            font-weight: bold;
            display: block;
        }

        .text {
            font-weight: normal;
        }

        .head,
        .text {
        }
    }
}

.email-view-title {
    > a {
        small {
            position: relative;
            top: -1px;
        }
    }
}

.email-events {
    background-color: lighten($color-light-grey, 15%);
    font-size: 12px;
    border: solid $color-light-grey;
    border-width: 0 0 1px 0;
    transition: all 0.5s ease-in-out;

    max-height: 0;
    overflow: hidden;

    &.show {
        max-height: 300px;
        overflow-y: scroll;
    }

    .email-events-inner {
        padding: 10px;
    }

    .event-card {
        background-color: rgba(#fff, 0.75);
        padding: 15px;
        margin: 15px 0;
        position: relative;

        .event-card-line {
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .event-card-title {
            position: absolute;
            top: 0;
            right: 0;
            background-color: rgba($color-blue, 1);
            padding: 5px 15px;
            font-weight: bold;
            color: #fff;
        }

        a {
            color: $color-blue;
        }
    }
}
</style>

<style lang="scss">
.email-event-tooltip .tooltip-inner {
}
</style>
